/***
 * 注册im全局组件
 * **/
import Vue from 'vue'

// 遍历当前目录下的所有vue文件
const req = require.context('../components', true, /\.vue$/)
// 如果是目录中的文件，就注册为全局组件
req.keys().forEach(fileName => {
  const componentConfig = req(fileName)
  // console.log(componentConfig)

  // 获取文件名字
  const componentName = fileName.split('/')[1].split('.')[0]
  // console.log('目录名字', fileName.split('/')[1])

  // const componentName = componentConfig.default.name
  // console.log(componentName)
  if (componentName) {
    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})
